@import "src/less/variables.less";

.outerContainer {
  margin-right: auto;
  margin-left: auto;
  max-width: @container-max-width;
  width: 100%;
  padding: 0 1em var(--dds-spacing-medium-32);
  flex: 1;
}
